export const signupReasons = [
  {
    key: 'in-person',
    value: 'interchange0-15',
    label: 'Take In-Person Payments',
  },
  { key: 'send-invoice', value: 'interchange0-18', label: 'Send Invoices' },
  { key: 'online', value: 'interchange0-18', label: 'Online Payments' },
  {
    key: 'mobile-reader',
    value: 'interchange0-18',
    label: 'Mobile Reader Payments',
  },
  { key: 'api', value: 'interchange0-18', label: 'Use Stax API' },
  { key: 'other', value: 'interchange0-18', label: 'Other' },
];
